import React from 'react'
import '../css/index.scss'

export function FancyLoader({ label = 'Lädt…', className = '' }) {
  return (
    <div className={`fancy-loader ${className}`.trim()} aria-busy="true" aria-live="polite">
      <div className="fancy-loader__ring" aria-hidden="true" />
      <div className="fancy-loader__dot" aria-hidden="true" />
      {label ? <div className="fancy-loader__label">{label}</div> : null}
    </div>
  )
}

